"use client";

import posthog from "posthog-js";
import { useEffect } from "react";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Capture the error in PostHog with additional context
    if (process.env.NODE_ENV === "production" && posthog.__loaded) {
      posthog.captureException(error, {
        tags: {
          type: "global_error_boundary",
          digest: error.digest,
          critical: true,
        },
        extra: {
          componentStack: (error as any).componentStack,
          errorBoundary: "global_error",
          url: window.location.href,
          userAgent: navigator.userAgent,
          timestamp: new Date().toISOString(),
        },
      });
    }

    // Also log to console for debugging
    console.error("Global error boundary caught:", {
      error,
      digest: error.digest,
      message: error.message,
      stack: error.stack,
    });
  }, [error]);

  return (
    <html>
      <body>
        <div className="flex min-h-screen flex-col items-center justify-center p-4">
          <div className="max-w-md text-center">
            <h2 className="mb-4 text-2xl font-bold">Something went wrong!</h2>
            <p className="mb-6 text-gray-600">
              We&apos;ve been notified and are working to fix the issue.
            </p>
            <button
              onClick={() => reset()}
              className="rounded-md bg-blue-600 px-4 py-2 text-white hover:bg-blue-700 transition-colors"
            >
              Try again
            </button>
          </div>
        </div>
      </body>
    </html>
  );
}
